module.exports = __webpack_public_path__ + "img/stegi-radio-logo-black.1b0ad539.svg";